/* Dilligaf: enhance the native cloned mega menu; keep native links and mobile navigation. */
(() => {
  const updatePreview = (event) => {
    const link = event.target.closest('.tier-2 .dilligaf-mega a[data-menu-image]');
    if (!link) return;
    const panel = link.closest('.dilligaf-mega');
    const preview = panel.querySelector('.dilligaf-menu-preview');
    const img = preview?.querySelector('img');
    if (!img || img.getAttribute('src') === link.dataset.menuImage) return;
    img.removeAttribute('srcset');
    img.src = link.dataset.menuImage;
    img.alt = link.dataset.menuTitle;
    preview.querySelector('a').href = link.href;
    const title = preview.querySelector('.line-1');
    if (title) title.textContent = link.dataset.menuTitle;
  };
  document.addEventListener('pointerover', updatePreview);
  document.addEventListener('focusin', updatePreview);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const active = document.querySelector('.multi-level-nav .tier-1 a.expanded');
    if (active && window.theme?.closeOpenMenuItem) {
      window.theme.closeOpenMenuItem();
      active.focus();
    }
  });
})();
